// Write your code here
import './index.css'

const NoTFound = () => (
  <div className="main-container">
    <h1 className="ipl-heading">Page Not Found</h1>
  </div>
)

export default NoTFound
